import {
  Component,
  OnInit,
  Input,
  HostBinding,
  AfterViewInit,
  HostListener,
  EventEmitter,
} from '@angular/core';
import { PgFlagNotificationOptions } from './pg-flag-notification-options';
import {
  trigger,
  transition,
  style,
  state,
  animate,
} from '@angular/animations';
import { styleVariables } from '../../styles/variables';

@Component({
  selector: 'pg-flag-notification',
  templateUrl: './pg-flag-notification.component.html',
  styleUrls: ['./pg-flag-notification.component.scss'],
  animations: [
    trigger('transitionDisplay', [
      state(
        'visible-left',
        style({
          opacity: 1,
          visibility: 'visible',
          width: 'calc(100% - 16px)',
          left: '8px',
          right: 'auto',
          transform: 'translateX(0px)',
        })
      ),
      state(
        'visible-right',
        style({
          opacity: 1,
          visibility: 'visible',
          width: 'calc(100% - 16px)',
          right: '8px',
          left: 'auto',
          transform: 'translateX(0px)',
        })
      ),
      state(
        '*',
        style({
          opacity: 0,
          visibility: 'hidden',
          width: 'calc(100% - 16px)',
        })
      ),
      transition('hidden => visible-left', [
        style({
          opacity: 1,
          left: '8px',
          right: 'auto',
          visibility: 'visible',
          width: 'calc(100% - 16px)',
          transform: 'translateX(-400px)',
        }),
        animate(`200ms ${styleVariables.transitionCurveDeceleration}`),
      ]),
      transition('hidden => visible-right', [
        style({
          opacity: 1,
          right: '8px',
          left: 'auto',
          visibility: 'visible',
          width: 'calc(100% - 16px)',
          transform: 'translateX(400px)',
        }),
        animate(`200ms ${styleVariables.transitionCurveDeceleration}`),
      ]),
      transition('visible-left => hidden', [
        animate(
          `150ms ${styleVariables.transitionCurveAcceleration}`,
          style({
            transform: 'translateX(-400px)',
          })
        ),
      ]),
      transition('visible-right => hidden', [
        animate(
          `150ms ${styleVariables.transitionCurveAcceleration}`,
          style({
            transform: 'translateX(400px)',
          })
        ),
      ]),
    ]),
  ],
})
export class PgFlagNotificationComponent implements OnInit {
  @Input()
  options: PgFlagNotificationOptions;

  @Input()
  data: {
    title: string;
    body: string;
    action?: string;
    actionHandler?: Function;
  };

  notificationHide = new EventEmitter<void>();

  @Input()
  actionHandler: Function;

  @HostBinding('@transitionDisplay')
  displayState: 'hidden' | 'visible-left' | 'visible-right' = 'hidden';

  @HostBinding('style.max-width.px')
  get _styleMaxWidth() {
    if (this.options) {
      return this.options.maxWidth || 400;
    }
  }

  @HostBinding('style.bottom.px')
  get _styleBottom() {
    if (this.options && this.options.bottom) {
      return this.options.bottom;
    }
    return 8;
  }

  @HostBinding('class.pg-elevation-3')
  _classPgElevation = true;

  constructor() {}

  ngOnInit() {}

  show() {
    this.displayState =
      this.options.enterSide === 'left' ? 'visible-left' : 'visible-right';
  }
  hide() {
    this.displayState = 'hidden';
  }

  handleNotificationDismiss() {
    this.hide();
  }

  handleActionClicked() {
    if (this.data.actionHandler) {
      if (this.data.actionHandler()) {
        this.handleNotificationDismiss();
      }
    } else {
      this.handleNotificationDismiss();
    }
  }

  @HostListener('@transitionDisplay.done', ['$event'])
  onAnimationDone(event: any) {
    if (
      event.fromState === 'visible-right' ||
      event.fromState === 'visible-left'
    ) {
      if (event.toState === 'hidden') {
        this.notificationHide.emit();
      }
    }
  }
}
